import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";

export class HrTransform extends EldmlTransform {
  apply() {
    this.selector.find("hr").each(function (_: any, element: Element) {
      const hr = $(element);
      const thickness = hr.attr("thickness") ? hr.attr("thickness") : "1";
      const type = hr.attr("type") ? hr.attr("type") : "solid";
      const color = hr.attr("color") ? hr.attr("color") : "#ddd";
      let style = `border-top-width: ${thickness}px;`;
      style += `border-style: ${type};`;
      style += `border-color: ${color};`;
      hr.attr("style", style);
      // fix na chrome
      hr.removeAttr("color");
    });
  }
}
